import DefaultDataGraphSetting from "./DefaultDataGraphSettings.js";
import FutureContractsHeaderExpiryStateEnum from "../../../../../Constants/FutureContractsHeaderExpiryStateEnum";
import Serializable from "../../../../../Serialization/Serializable.js";

export default class FuturesViewSettings extends Serializable {
  onSeralisedInfoRecieved(info) {
    this.HiLoPriceSettings = info.HiLoPriceSettings ? info.HiLoPriceSettings : DefaultDataGraphSetting.getHiLoPriceSetting();
    this.HiLoPctSettings = info.HiLoPctSettings ? info.HiLoPctSettings : DefaultDataGraphSetting.getHiLoPctSetting();
    this.UpDaysSettings = info.UpDaysSettings ? info.UpDaysSettings : DefaultDataGraphSetting.getUpDaysSetting();
    this.MASettings = info.MASettings ? info.MASettings : DefaultDataGraphSetting.getMovingAverageSetting();
    this.VolumeBlockSettings = info.VolumeBlockSettings ? info.VolumeBlockSettings : DefaultDataGraphSetting.getDefaultVolumeBlockSettings(true);
    this.OpenInterestSettings = info.OpenInterestSettings ? info.OpenInterestSettings : DefaultDataGraphSetting.getDefaultOpenInterestSettings();
    this.ScaleLabelSettings = info.ScaleLabelSettings ? info.ScaleLabelSettings : DefaultDataGraphSetting.getScaleLabelSettings(false, true);
    this.OffHighTag = info.OffHighTag ? info.OffHighTag : "OH";
    this.expiryDateFormat = info.expiryDateFormat ? info.expiryDateFormat : FutureContractsHeaderExpiryStateEnum.CountDown;
    this.ExternalDataSettings =  info.ExternalDataSettings ? info.ExternalDataSettings : DefaultDataGraphSetting.getExternalDataSettings();
    this.EDMultiplierSettings = info.EDMultiplierSettings ? info.EDMultiplierSettings : DefaultDataGraphSetting.getMultiplierSetting(false);
    this.ExternalDataRiPanelSettings = info.ExternalDataRiPanelSettings ? info.ExternalDataRiPanelSettings : DefaultDataGraphSetting.getExternalDataRiPanelSettings();
    this.TiMenuSettings = info.TiMenuSettings ? info.TiMenuSettings : DefaultDataGraphSetting.getTiMenuSettings();
  }

  getDataObject() {
    return {
      HiLoPriceSettings: this.HiLoPriceSettings,
      HiLoPctSettings: this.HiLoPctSettings,
      UpDaysSettings: this.UpDaysSettings,
      MASettings: this.MASettings,
      VolumeBlockSettings: this.VolumeBlockSettings,
      OpenInterestSettings: this.OpenInterestSettings,
      OffHighTag: this.OffHighTag,
      ScaleLabelSettings: this.ScaleLabelSettings,
      expiryDateFormat: this.expiryDateFormat,
      ExternalDataSettings: this.ExternalDataSettings,
      ExternalDataRiPanelSettings: this.ExternalDataRiPanelSettings,
      TiMenuSettings: this.TiMenuSettings
    };
  }

  getObjectMapKey() {
    return "FuturesViewSettings";
  }
  getMovingAverageSettingObject(ma, maType, isVisible, lineColor, lineThickness) {
    return DefaultDataGraphSetting.getMovingAverageSettingObject(ma, maType, isVisible, lineColor, lineThickness);
  }
}